export default class AskAboutData {
  constructor(context) {
    this.context = context;
  }

  run({ question, analyticsConversationId, timezone, history, onSuccess, onError }) {
    const isDemoMode = this.context.stores.appFeatures.get().isEnabled('demoMode');

    const request = isDemoMode
      ? this.context.gateways.conversationalAnalytics.chatDemo({ question, history })
      : this.context.gateways.conversationalAnalytics.chat({ question, analyticsConversationId, timezone });

    request.then(response => onSuccess(response)).catch(error => onError(error));
  }
}
